import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";
import Dashboard from "../Dashboard/Dashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faArrowLeft,faFilePdf } from "@fortawesome/free-solid-svg-icons";
import "../DeepDrive/DeepDrive.css";
import gg from "../../../src/images/pp-logo.gif"

function PastAttempts({ globaltest }) {

  const navigate = useNavigate();
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [BannerContent, setBannerContent] = useState({});

  useEffect(() => {

    const fetchAttempts = async () => {

      const token = localStorage.getItem("token");
      if (!token) {

        console.error("User not authenticated");
        navigate("/login");
        return;
      }

      try {
        
        const response = await axios.get(`${END_URL}/user-answers/history`, {

          headers: { Authorization: `Bearer ${token}` },
        });

        setAttempts(response?.data?.deep_answers || []);

        setBannerContent(response?.data?.banner_content || {});
        setLoading(false);
      } catch (error) {
        console.error("Error fetching attempts:", error);
        setLoading(false);
      }
    };

    fetchAttempts();

    window.scrollTo(0, 0);

  }, [navigate]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleViewAttempt = (attemptId) => {
    navigate(`/view-attempt/${attemptId}`);
  };

    const handlepdf = async (item_id,pdf_url) => {

      const token = localStorage.getItem("token");

      try {
          await axios.post(

            `${END_URL}/update/32_question/${item_id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          window.location = pdf_url;

        } catch (error) {
          
          console.error("Failed to update notification", error);
          
          window.location = pdf_url;
        }

    };
  

  return (
    <div className="deep-main past-result-main">
      
      <div className="container-fluid deep-fluid past-result-cont">
     
      {loading ? (

          
          <div className="loadingDiv">
                         <img
                      src={gg}
                      alt="Loading..."

                    />
            </div>

        ) : (

        <div className="row deep-sec-row">

          <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

            <Dashboard globaltest={globaltest} />

          </div>

          <div className="col-12 col-sm-12 col-md-8">

            <div className="deep-inner-outer past-result">

              <h3 style={{ marginBottom: "20px" }}>{BannerContent?.deep_drive_history_title}</h3>

              {loading ? (

                  <div className="asm-card-bx2">
   
                        </div>
                
              ) : attempts.length === 0 ? (

                <div className="alert alert-warning">
                  No past attempts found. Take the test to see your history here.
                </div>
              ) : (

                <div className="attempts-list">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th></th>
                        <th>{BannerContent?.history_table_col_1}</th>
         
                        <th>{BannerContent?.history_table_col_2}</th>

                        <th>{BannerContent?.history_table_col_3}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attempts.map((attempt, index) => (
                        <tr key={attempt.id}>
                          <td>{index + 1}</td>
                          <td>{formatDate(attempt.created_at)}</td>
                     
                          <td>
                                {attempt.pdfcollection && (

                                    <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handlepdf(attempt?.id,`${IMG_URL}/d0/feed-back/${attempt?.id}/${attempt?.pdfcollection}`)}
                                    >
                                    <FontAwesomeIcon icon={faFilePdf} /> {BannerContent?.history_feed_back_btn}
                                    </button>
                                )}
                        </td>

                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => handleViewAttempt(attempt.id)}
                            >
                              <FontAwesomeIcon icon={faEye} /> {BannerContent?.history_action_btn}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
        )}


      </div>
    </div>
  );
}

export default PastAttempts;